import * as Constants from '../Constant';

const initialState = {
    message: {},
    patientVisit: {},
    invoiceStat: {}
}

export default function dashboardReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.GET_PATIENT_VISITS:
            return {
                ...state,
                patientVisit: action.payload,
            }
        case Constants.GET_INVOICE_STATS:
            return {
                ...state,
                invoiceStat: action.payload,
            }
        default:
            return state;
    }
}